/**
 * The `<hr>` carries the className. There is always exactly one element and it
 * is always the root, so there is nothing for this to depend on.
 */
export const resolveRendersOwnElement = (): boolean => true;
